import React from 'react';
import { Container, Row} from 'react-bootstrap';
import FaqCard from './FaqCard';

import FaqIcon1 from '../../assets/img/title-icon.png';

const questions = [
    {
        no: "01",
        title: "車衣有尺寸參考表嗎？",
        ans: "請詳見本官網 ➜「環法挑戰賽限定禮盒」；或於伊貝特報名頁面點擊「環法挑戰賽限定禮盒」紀念車衣處連結。",
    },
    {
        no: "02",
        title: "什麼時候會收到環法挑戰賽限定選手物資呢？",
        ans: "選手物資預計9/22起陸續寄出，如9/26前尚未收到，請透過官方LINE（https://lin.ee/PWu064q ）聯繫。報名時選擇至指定Specialized經銷商取件者，請至所選經銷商領取；海外選手請於活動前一日或活動當日鳴槍前至大會服務台領取。",
    },
    {
        no: "03",
        title: "什麼時候會收到加購商品呢？",
        ans: "加購商品將與您的選手物資一併寄出，預計9/22起陸續寄出。",
    },
    {
        no: "04",
        title: "如果車衣尺寸不符合，可以更換嗎？",
        ans: "報名後尚未完成繳費者，可至伊貝特報名系統自行修改尺寸資訊；已完成繳費者請洽伊貝特客服（週一至週五10:00～18:00）。物資寄出後，恕無法接受更換車衣尺寸，請大家審慎填寫報名表。",
    },
    {
        no: "05",
        title: "如果想加購禮盒內商品可以嗎？",
        ans: "報名已於2026/8/15截止，如有加購相關問題，請洽官方LINE（https://lin.ee/PWu064q ）。",
    },
]

const questionsEng = [
    {
        no: "01",
        title: "Is there a size chart for the cycling jersey?",
        ans: "See the 'L'Étape Exclusive Gift Box' page on this website ➜ or, on the Ebet registration page, click the commemorative jersey link under 'L'Étape Exclusive Gift Box'.",
    },
    {
        no: "02",
        title: "When will I receive my L'Étape race kit?",
        ans: "Race kits are expected to ship from around September 22. If you have not received yours by September 26, please contact us via our official LINE account (https://lin.ee/PWu064q). If you chose pickup at a designated Specialized dealer when registering, collect your kit from that dealer. Overseas riders collect their kits at the event service desk the day before the event or on race day before the start.",
    },
    {
        no: "03",
        title: "When will I receive my add-on items?",
        ans: "Add-on items will be shipped together with your race kit, from around September 22.",
    },
    {
        no: "04",
        title: "Can I exchange my jersey if the size doesn't fit?",
        ans: "If you have registered but not yet paid, you can change your size yourself in the Ebet registration system. If you have already paid, please contact Ebet customer service (Monday to Friday, 10:00 AM - 6:00 PM). Once your race kit has been shipped, jersey sizes cannot be exchanged, so please fill out the registration form carefully.",
    },
    {
        no: "05",
        title: "Can I buy extra items from the gift box?",
        ans: "Registration closed on August 15, 2026. For questions about add-ons, please contact our official LINE account (https://lin.ee/PWu064q).",
    },
]

const GiftQ = ({language}) => {
    return (
        <section className="faq-gift">
            <Container>
                <Row className='align-items-center faq-section'>
                    <h2 className='faq-header'><span><img className='faq-icon' src={FaqIcon1} alt="" /></span>{language === "Chinese" ? "環法挑戰賽限定選手物資相關問題" : "Race Kit"}</h2>
                    {language === "Chinese" ? 
                        questions.map((q, index) => (
                            <FaqCard
                                key={index}
                                {...q}
                            />
                        ))
                    : 
                        questionsEng.map((q, index) => (
                            <FaqCard
                                key={index}
                                {...q}
                            />
                        ))
                    }
                </Row>
            </Container>
        </section>
    )
}

export default GiftQ